// Resolve the host page at click time, including when shared UI is in a modal.
export function getUiContext(pathname) {
    const route = pathname.split('/dashboard/')[1] ?? pathname.replace(/^\//, '')
    const [module = 'unknown', section, , tab] = route.split('/')
    let page = section || 'overview'
    if (module === 'intelligence' && section === 'brands') page = route.split('/').length > 4 ? 'ad-details' : `advertiser-${tab || 'overview'}`
    if (module === 'intelligence' && section === 'boards' && route.split('/').length > 2) page = 'board-details'
    if (module === 'creative' && section === 'views') page = 'reports'
    return { module, page, pathname }
}
